import React, {useState} from 'react';
import {useIsMobile} from "../../../../../hoc/hooks";

interface AccordionItemProps {
    label: string;
    openByDefault: boolean;
}

export const AccordionItem: React.FC<AccordionItemProps> = ({label, openByDefault, children}) => {
    const isMobile = useIsMobile('768px');
    const isOpenByDefault = openByDefault && !isMobile;
    const [isOpen, setIsOpen] = useState(isOpenByDefault);

    const toggleAccordion = () => {
        setIsOpen(!isOpen);
    };

    const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            toggleAccordion();
        }
    };

    return (
        <div
            className={`${isOpen ? "accordion__item accordion__item--open" : "accordion__item"}`}
        >
            <div
                className="accordion__label"
                 role={"button"}
                 tabIndex={0}
                 aria-expanded={isOpen}
                 onKeyDown={handleKeyDown}
                 onClick={toggleAccordion}
            >
                {label}
            </div>
            <div
                aria-hidden={!isOpen}
                className={`${isOpen ? "accordion__content" : "accordion__content accordion__content--closed"}`}
            >
                {children}
            </div>
        </div>
    );
};
